import { observer } from 'mobx-react-lite';
import { useFormContext } from 'react-hook-form';
import { FormBody } from '../../../forms/integrated-form-components/form-body';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { EventPanelFormType } from '@mark43/cad-api';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { TabSubtitle } from '../../../panels/entity-panels/tabs/tab-subtitle';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { Box } from '@cad-arc';
import { EventPanelFormPersonsFields } from '../../event-panel-form/involved-person-vehicle-fields/persons/event-panel-form-persons-fields';
import { EventPanelFormArrayCount } from '../components/event-panel-form-array-count';

export const PersonsTab = observer(function PersonsTab() {
    const eventForm = useFormContext<EventPanelFormType>();
    const eventMetadata = useEventMetadataStore().state.metadata;
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const eventPanelConfig = useBootstrapState().eventPanelConfiguration;

    return (
        <EventPanelTab title="Persons">
            <TabBody>
                <TabSubtitle>
                    Reporting Parties (<EventPanelFormArrayCount name="reportingParties" />)
                </TabSubtitle>
                <FormBody>
                    <>
                        <EventPanelFormPersonsFields
                            form={eventForm}
                            displayAsCards
                            allowMembersControl
                            noMembersText="No Reporting Parties"
                            baseKey="reportingParties"
                            addButtonText="Add Reporting Party"
                            eventPanelOptions={eventPanelOptions!}
                            eventPanelConfig={eventPanelConfig}
                        />

                        <Box pt={4}>
                            <TabSubtitle>
                                Involved Persons (<EventPanelFormArrayCount name="involvedPersons" />)
                            </TabSubtitle>
                            <EventPanelFormPersonsFields
                                displayAsCards
                                allowMembersControl
                                form={eventForm}
                                noMembersText="No Involved Persons"
                                baseKey="involvedPersons"
                                addButtonText="Add Involved Person"
                                eventPanelOptions={eventPanelOptions!}
                                eventPanelConfig={eventPanelConfig}
                            />
                        </Box>

                        {eventMetadata?.hasMergedEvents && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Merged Reporting Parties (
                                    <EventPanelFormArrayCount name="mergedReportingParties" />)
                                </TabSubtitle>
                                <EventPanelFormPersonsFields
                                    displayAsCards
                                    form={eventForm}
                                    noMembersText="No Merged Reporting Parties"
                                    allowMembersControl={false}
                                    baseKey="mergedReportingParties"
                                    eventPanelOptions={eventPanelOptions!}
                                    eventPanelConfig={eventPanelConfig}
                                />
                            </Box>
                        )}

                        {eventMetadata?.hasMergedEvents && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Merged Involved Persons (
                                    <EventPanelFormArrayCount name="mergedInvolvedPersons" />)
                                </TabSubtitle>
                                <EventPanelFormPersonsFields
                                    displayAsCards
                                    form={eventForm}
                                    noMembersText="No Merged Involved Persons"
                                    allowMembersControl={false}
                                    baseKey="mergedInvolvedPersons"
                                    eventPanelOptions={eventPanelOptions!}
                                    eventPanelConfig={eventPanelConfig}
                                />
                            </Box>
                        )}
                    </>
                </FormBody>
            </TabBody>
        </EventPanelTab>
    );
});
